import { useMutation, useQueryClient } from '@tanstack/react-query';
import tourInstallmentsApi from '@/features/dashboard/tourConfig/api/tourInstallmentsApi.ts';
import { tourInstallmentDtoMapper } from '@/features/dashboard/tourConfig/types/TourInstallmentDto.mapper.ts';
import { TourInstallmentForm } from '@/features/dashboard/tourConfig/schemas/tourInstallmentsSchema.ts';
import { toast } from 'sonner';
import { tourInstallmentsApiQueryKeys } from '@/features/dashboard/tourConfig/api/tourInstallmentsApi.queryKeys.ts';

export default function useWriteTourInstallments(tourId: string) {
  const queryClient = useQueryClient();

  const writeTourInstallments = async (
    installmentsForm: TourInstallmentForm,
  ) => {
    const request =
      tourInstallmentDtoMapper.fromFormToRequest(installmentsForm);
    return await tourInstallmentsApi.writeInstallments(tourId, request);
  };

  return useMutation({
    mutationFn: writeTourInstallments,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourInstallmentsApiQueryKeys.byTour(tourId),
      });
      toast.success('Raty zostały zapisane');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd podczas zapisywania rat', {
        description: error.message,
      });
    },
  });
}
